<template>
  <div class="col">
    <ArtworkDetails
      :internetAuction="internetAuction"
    />
    <BidPanel
      v-if="auctionStateIsStarted"
      :internetAuction="internetAuction"
    />
  </div>
</template>

<script>
  import { AUCTION_STARTED_STATE } from '@/internet_auctions/consts';
  import BidPanel from './bid_panel';
  import ArtworkDetails from './artwork_details';

  export default {
    name: 'AuctionContent',
    components: {
      ArtworkDetails,
      BidPanel,
    },
    props: {
      internetAuction: {
        type: Object,
        required: true,
      },
    },
    computed: {
      auctionStateIsStarted() {
        return this.internetAuction.state === AUCTION_STARTED_STATE;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/internet_auctions/components/modal/auction_content.vue?6e389cb0